import type { DatePickerValue } from '@civilgrid/ui/components';

export type WorkTypeRadio = 'main' | 'service' | 'emergency';
export type ContractorType = 'atmos' | 'contractor' | 'other';

/** One contractor row on a permit (up to 5). Mirrors the server-side `Contractor` on the permitPdf table. */
export type Contractor = {
  type: ContractorType;
  /** Contractor / company name. */
  name: string;
  /** Construction rep name. */
  repName: string;
  email: string;
  phone: string;
};

/** Maximum number of contractor rows a permit can hold. */
export const MAX_CONTRACTORS = 5;

export type PermittingFormValues = {
  permitSubmissionDate: DatePickerValue | null;
  permitSubmissionContactName: string;
  permitSubmissionContactEmail: string;
  permitSubmissionContactPhone: string;
  workStartDate: DatePickerValue | null;
  workEndDate: DatePickerValue | null;
  projectNumber: string;
  address: string;
  city: string;
  zip: string;
  atmosRep: string;
  atmosEmail: string;
  atmosPhone: string;
  workTypeText: string;
  workTypeRadio: WorkTypeRadio;
  contractors: Contractor[];
  /** When true, the printed map is rendered on its own page instead of below the form. */
  mapOnSeparatePage: boolean;
};

/** A blank contractor row (used when the user adds a row or seeds the first one). */
export function emptyContractor(): Contractor {
  return { type: 'atmos', name: '', repName: '', email: '', phone: '' };
}
